import { useEffect, useRef, useState } from "react";
import {
  ACCESS_TOKEN_KEY,
  COMPANY_ROLE,
  COOKIES_COMPANY_ID,
  COOKIES_USER_ID,
} from "../utils/constants";
import Cookies from "js-cookie";

export default function useWebSocket() {
  const [socket, setSocket] = useState<WebSocket>();
  const [wsUrl, setWsUrl] = useState<string>(
    process.env.REACT_APP_WEBSOCKET_ENPOINT!
    // "wss://beya2vspvc.execute-api.us-east-1.amazonaws.com/dev/"
  );
  const reconnectRef = useRef<NodeJS.Timeout>();

  useEffect(() => {
    buildWebsocket();
    return () => handleClose();
  }, []);

  const buildWebsocket = async () => {
    let url = wsUrl;
    if (!url) {
      // url = await fetchWebsocketURL();
      setWsUrl(url);
    }

    console.log("fetched url", url);
    const [userID, companyID, token] = getUserInfo();
    const ws = new WebSocket(
      `${url}?Authorization=Bearer%20${token}&companyID=${companyID}&userID=${userID}`
    );
    setSocket(ws);
  };

  const handleReconnect = () => {
    console.warn("⚠️ WebSocket closed. Reconnecting...");
    reconnectRef.current = setTimeout(() => buildWebsocket(), 15000);
  };

  const handleClose = () => {
    socket?.close();
    if (reconnectRef.current) clearTimeout(reconnectRef.current);
  };

  const sendAction = (action: string, payload: any) => {
    if (socket?.readyState === WebSocket.OPEN) {
      const [userID, companyID, token] = getUserInfo();

      socket.send(
        JSON.stringify({
          action,
          payload,
          headers: {
            Authorization: `Bearer ${token}`,
            userID,
            companyID,
            companyRole: COMPANY_ROLE.carrier,
          },
        })
      );
    }
  };

  const getUserInfo = () => {
    const token = Cookies.get(ACCESS_TOKEN_KEY);
    const companyID = Cookies.get(COOKIES_COMPANY_ID);
    const userID = Cookies.get(COOKIES_USER_ID);
    return [userID, companyID, token];
  };

  return { socket, sendAction, handleReconnect, handleClose };
}
